<template>
    <div class="com-item intro-module" :key="index">
        <div class="component person-nav">
            <div
                class="van-sticky"
                :style="{
                    backgroundColor: modata.WContent.bgColor || 'transparent',
                    backgroundImage: modata.WContent.bgImg ? 'url(' + modata.WContent.bgImg + ')' : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    color: modata.WContent.textColor || '#333'
                }"
            >
                <div class="intro-module__inner">
                    <ul class="intro-module__nav" v-if="modata.WContent.navList && modata.WContent.navList.length">
                        <li
                            v-for="(item, nIdx) in modata.WContent.navList"
                            :key="nIdx"
                            class="intro-module__nav-item"
                        >
                            <div class="intro-module__nav-icon">
                                <img v-if="item.icon" :src="item.icon" alt="" />
                            </div>
                            <div class="intro-module__nav-text">
                                <div class="intro-module__nav-num">
                                    <span class="intro-module__nav-value">{{ item.value }}</span>
                                    <span class="intro-module__nav-unit">{{ item.unit }}</span>
                                </div>
                                <p class="intro-module__nav-label">{{ item.label }}</p>
                                <a
                                    v-if="item.linkUrl"
                                    class="intro-module__nav-link"
                                    :href="item.linkUrl"
                                    target="_blank"
                                >{{ item.linkName || '查看详情' }} &gt;</a>
                            </div>
                        </li>
                    </ul>

                    <div v-if="modata.WContent.videoUrl" class="intro-module__video">
                        <video
                            ref="video"
                            :src="modata.WContent.videoUrl"
                            :poster="modata.WContent.videoPoster"
                            :controls="playStatus"
                            width="100%"
                            height="100%"
                        ></video>
                        <div
                            v-show="!playStatus"
                            class="intro-module__video-mask"
                            :class="{ 'intro-module__video-mask--hide': playStatus }"
                            @click="changePlay"
                        >
                            <span class="intro-module__video-icon">
                                <i class="el-icon-caret-right" style="font-size: 36px; line-height: 60px;" v-show="!playStatus"></i>
                            </span>
                        </div>
                    </div>
                    <div v-else class="no-modata">请设置视频模块内容</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "intro-module",
    components: {},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'intro',
                    Title: '企业介绍',
                    MID: 13,
                    WID: null,
                    ModuleName: 'intro-module',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {
            playStatus: false
        }
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        changePlay() {
            if (!this.$refs.video) return
            if (this.playStatus) this.$refs.video.pause()
            else this.$refs.video.play()
            this.playStatus = !this.playStatus
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.intro-module {
    min-height: 300px;
    position: relative;

    .intro-module__inner {
        width: 90%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 4% 0 2%;
        box-sizing: border-box;
    }

    .intro-module__nav {
        list-style: none;
        margin: 0 auto 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        max-width: 100%;
        width: 90%;
    }

    .intro-module__nav-item {
        flex: 0 0 33.3%;
        position: relative;
        padding: 0 12px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        margin-bottom: 6%;
    }

    .intro-module__nav-icon {
        max-width: 48px;
        margin: 0;
        display: flex;
        align-items: start;
        justify-content: center;

        img {
            width: 100%;
            height: auto;
            object-fit: contain;
            margin-right: 8px;
        }
    }

    .intro-module__nav-text {
        flex: 1;
        min-width: 0;
    }

    .intro-module__nav-num {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        width: 100%;
        margin: 0;
    }

    .intro-module__nav-value {
        flex: 0 0 auto;
        font-size: 45px;
        font-weight: normal;
        font-family: "pingfang heavy", "PingFang SC", "Microsoft YaHei", sans-serif;
        line-height: 1;
        color: rgba(0, 78, 162, 1);
    }

    .intro-module__nav-unit {
        align-self: center;
        font-size: 20px;
        padding-left: 5px;
        line-height: normal;
        color: rgba(0, 78, 162, 1);
    }

    .intro-module__nav-label {
        font-size: 16px;
        text-align: left;
        line-height: normal;
        margin: 5px 0 0;
    }

    .intro-module__nav-link {
        display: inline-block;
        font-size: 12px;
        color: inherit;
        text-decoration: none;
        opacity: 0.7;
        margin-top: 4px;

        &:hover { opacity: 1; }
    }

    .intro-module__video {
        position: relative;
        min-height: 300px;
        width: 90%;
        max-width: 1600px;
        margin: 3% auto 0;

        video {
            display: block;
            max-height: 34vw;
            border-radius: 20px;
            background: #000;
        }
    }

    .intro-module__video-mask {
        position: absolute;
        inset: 0;
        background-color: rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .intro-module__video-mask--hide { display: none; }

    .intro-module__video-icon {
        width: 60px;
        height: 60px;
        background: #fff;
        border-radius: 30px;
        text-align: center;
        box-shadow: 0 0 10px #dedede;
        cursor: pointer;
    }
}

@media screen and (max-width: 768px) {
    .intro-module {
        .intro-module__nav-item {
            flex: 0 0 50%;
            margin-bottom: 30px;
        }
        .intro-module__nav-num {
            margin-bottom: 10px;
        }
        .intro-module__nav-value {
            font-size: 28px;
            line-height: 1;
        }
        .intro-module__nav-unit {
            font-size: 14px;
            line-height: 1;
        }
        .intro-module__nav-label {
            font-size: 14px;
            line-height: 1;
            margin-top: 0;
        }
        .intro-module__nav-icon {
            max-width: 30px;
            flex: 0 0 auto;
            margin-right: 10px;
        }
        .intro-module__video {
            min-height: 0;
            max-height: none;
            height: auto;
        }
    }
}
</style>
